import { createContext } from 'react';

// By default, we assume we are in a mobile viewport
// because that where the majority of users come from
const ViewportContext = createContext({
    isMobile: true,
    isTablet: false,
    isDesktop: false,
    viewport: 'mobile',
});

export { ViewportContext };
//# sourceMappingURL=ViewportContext.js.map
